import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon, ShoppingCartIcon } from 'lucide-react';
interface ProductCardProps {
  id: string;
  name: string;
  price: number;
  image: string;
  category: string;
  isNew?: boolean;
  isBestseller?: boolean;
}
export function ProductCard({
  id,
  name,
  price,
  image,
  category,
  isNew,
  isBestseller
}: ProductCardProps) {
  // Determine if product qualifies for free shipping
  const hasFreeShipping = price >= 6000;
  return <div className="group relative" data-id="element-363">
      <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-100" data-id="element-364">
        <img src={image} alt={name} className="h-64 w-full object-cover object-center group-hover:opacity-90 transition-opacity" data-id="element-365" />
        <div className="absolute top-2 right-2 flex flex-col gap-2" data-id="element-366">
          <button className="p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors" data-id="element-367">
            <HeartIcon className="h-4 w-4 text-gray-600" data-id="element-368" />
          </button>
          <button className="p-2 bg-pink-700 rounded-full shadow-md hover:bg-pink-800 transition-colors" data-id="element-369">
            <ShoppingCartIcon className="h-4 w-4 text-white" data-id="element-370" />
          </button>
        </div>
        <div className="absolute top-2 left-2 flex flex-col gap-1" data-id="element-371">
          {isNew && <div className="bg-pink-500 text-white text-xs font-semibold px-2 py-1 rounded" data-id="element-372">
              New
            </div>}
          {isBestseller && <div className="bg-amber-500 text-white text-xs font-semibold px-2 py-1 rounded" data-id="element-373">
              Bestseller
            </div>}
          {hasFreeShipping && <div className="bg-green-500 text-white text-xs font-semibold px-2 py-1 rounded" data-id="element-374">
              Free Delivery
            </div>}
        </div>
      </div>
      <div className="mt-4" data-id="element-375">
        <div className="text-xs text-gray-500 mb-1" data-id="element-376">{category}</div>
        <h3 className="text-sm font-medium text-gray-900" data-id="element-377">
          <Link to={`/product/${id}`} data-id="element-378">
            <span aria-hidden="true" className="absolute inset-0" data-id="element-379" />
            {name}
          </Link>
        </h3>
        <p className="mt-1 text-sm font-medium text-pink-700" data-id="element-380">
          KES {price.toLocaleString()}
        </p>
      </div>
    </div>;
}